<template>
  <div id="app">
    <videoBackground></videoBackground>
    <topHeader></topHeader>
    <router-view/>
    <modal></modal>
  </div>
</template>

<script>
import Header from '@/components/Header'
import VideoBackground from '@/components/Video'
import Modal from '@/components/Modal'
import { Bus } from '@/components/Bus'

export default {
  name: 'App',
  components: {
    'topHeader': Header,
    'videoBackground': VideoBackground,
    'modal': Modal
  },
  beforeMount: function () {
    const body = document.getElementsByTagName('body')[0]

    Bus.$on('closeModal', () => {
      body.classList.remove('modal-open')
    })
  },
  mounted: function () {
    const body = document.getElementsByTagName('body')[0]

    Bus.$on('noResults', () => {
      body.classList.add('modal-open')
    })

    Bus.$on('openModal', () => {
      body.classList.add('modal-open')
    })
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: block;
  width: 100%;

  @media screen and (max-height: 820px) {
    min-height: 650px;
  }

  @media screen and (max-width: 767px) and (max-height: 820px) {
    min-height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue